import { HeaderMenu } from "components"
import { useSearchParams } from "react-router-dom"
import { DateRangeTab } from "./DateRangeTab"
import { TabNavRegister } from "../components/TabNavRegister"
import { TabRegisterPath } from "../types"
// import { useState } from "react"

type TabsSearchParams = {
  tabs: TabRegisterPath
}


export default function ProjectRegister() {
  const [searchParams, setSearchParams] = useSearchParams({ tabs: "date-range" } as TabsSearchParams)
  const activeTab = searchParams.get("tabs")
  const setActiveTab = (path: string) => setSearchParams({ tabs: path })

  return (
      <section className="container my-5">
        <HeaderMenu title="PROJECT REGISTER" className="sticky top-[0px] z-[1]" />
        <TabNavRegister activeTab={activeTab!} setActiveTab={setActiveTab} />
        {activeTab === "date-range" && <DateRangeTab />}
        {/* <Footer activeTab={activeTab} /> */}
      </section>
  )
}

// function Footer(props: { activeTab: string | null }) {

//   const [isOpenModal, setIsOpenModal] = useState<{ isOpen: boolean; type: "excel" | "pdf" | string, activeTab: string | null }>({
//     isOpen: false,
//     type: "",
//     activeTab: props.activeTab
//   })

//   return (
//     <>
//       <FooterMenu
//         export={{
//           actiontype: "export",
//           onClick: () => setIsOpenModal({
//             isOpen: true,
//             type: "excel",
//             activeTab: props.activeTab
//           })
//         }}

//         pdf={{
//           actiontype: "pdf",
//           onClick: () => setIsOpenModal({
//             isOpen: true,
//             type: "pdf",
//             activeTab: props.activeTab
//           })
//         }}
//       />

     

//     </>
//   )
// }


